<template>
  <div :id="id" :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-default-prop
    linedata: {
      type: Object
    },
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data() {
    return {
      chart: null,
      services: []
    }
  },
  mounted() {
    console.log('数据显示xdata-=-==-=' + JSON.stringify(this.linedata.xdata) + '-=-=-linename-=-=-' + JSON.stringify(this.linename))
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    configSevice() {
      var rgbarray = [

        {
          // 绿色
          areacolor: 'rgba(137, 189, 27, 0.3)',
          itemcolor: 'rgb(137,189,27)',
          borderColor: 'rgba(137,189,2,0.27)'
        },
        {
          // 蓝色
          areacolor: 'rgba(0, 136, 212, 0.3)',
          itemcolor: 'rgb(0, 136, 212)',
          borderColor: 'rgba(0,136,212,0.27)'
        },
        {
          // 红色
          areacolor: 'rgba(219, 50, 51, 0.3)',
          itemcolor: 'rgb(219, 50, 51)',
          borderColor: 'rgba(219, 50, 51,0.27)'
        }

      ]
      this.linedata.ydata.filter((item, i) => {
        console.log('循环==i==', JSON.stringify(item))
        var dic = {
          name: this.linedata.linename[i],
          type: 'line',
          smooth: true,
          symbol: 'circle',
          // 提示框圆形图标大小
          symbolSize: 5,
          // 默认显示该线条所以节点圆形图标
          showSymbol: true,
          lineStyle: {
            normal: {
              width: 1
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: rgbarray[i].areacolor
              }], false),
              // shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          // 提示框圆形图案图标以及外圈样式
          itemStyle: {
            normal: {
              color: rgbarray[i].itemcolor,
              borderColor: rgbarray[i].borderColor,
              borderWidth: 12

            }
          },
          data: item
        }
        this.services.push(dic)
      })
    },
    initChart() {
      this.configSevice()
      this.chart = echarts.init(document.getElementById(this.id))

      this.chart.setOption({
        backgroundColor: null,
        title: {
          top: 20,
          text: '曲线数据',
          textStyle: {
            fontWeight: 'normal',
            fontSize: 20,
            color: '#F1F1F3'
          },
          left: '1%'
        },
         tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: '#57617B'
            }
          }
        },
        legend: {
          top: 20,
          icon: 'rect',
          itemWidth: 14,
          itemHeight: 5,
          itemGap: 13,
          data: this.linename,
          right: '4%',
          textStyle: {
            fontSize: 12,
            color: '#F1F1F3'
          }
        },
        grid: {
          top: 100,
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#A1F1E3'

            }
          },
          data: this.linedata.xdata
        }],
        yAxis: [{
          type: 'value',
          name: '(%)',
          axisTick: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: '#A1F1E3'
            }
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 14
            }
          },
          splitLine: {
            lineStyle: {
              color: '#57617B'
            }
          }
        }],
        series: this.services
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chart/LineMarker.vue